module.exports = __webpack_public_path__ + "img/ES-M-10.3dcd7097.svg";